<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- alert -->
    <div>
      <v-alert
        :type="alert_type"
        :model-value="alert"
        :value="alert"
        transition="scale-transition"
        >{{ alert_message }}</v-alert
      >
    </div>
    <!-- Approve / reject popup -->
    <v-dialog v-model="confirmationModelDelete" persistent max-width="450px">
      <v-card class="v-card-100">
        <v-card-title class="d-flex align-center">
          <span>Confirmation</span>
          <v-spacer></v-spacer>
          <v-btn variant="solo" icon @click="confirmationModelDelete = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="text-center pt-6">
          <span> {{ accessMessage }} </span>
        </v-card-text>
        <v-card-actions center>
          <v-spacer></v-spacer>
          <v-btn size="small" class="bg-blue" color="white" @click="confirmedFunc()">Confirm</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--  Success messeage popup -->
    <v-row justify="center">
      <v-dialog v-model="successPopUp" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="successPopUp = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span> {{ successmessage }}</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="white" class="mb-3 bg-blue" @click="afterClickOkLoadData"
              >OK</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Tab header section -->
    <div>
      <HeaderComponent :headerTitle="headerText" />
    </div>
    <!-- search action and filter -->
    <v-card-title>
    <v-row class="me-3 my-3">
      <v-row>
        <v-col cols="8" sm="8">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            v-model="pending_return_search"
            label="Search"
            style="max-width: 300px"
            color="blue"
            variant="outlined"
            v-on:keyup.enter="loadData()"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>
      <v-actions style="margin-bottom: 28px">
        <v-btn
          class="ma-2"
          :color="this.selected.length == 0 ? '' : 'primary'"
          :disabled="selected.length == 0"
          @click="approveItems()"
          >Approve</v-btn
        >
        <v-btn
          class="ma-2"
          :color="this.selected.length == 0 ? '' : 'primary'"
          :disabled="selected.length == 0"
          @click="rejectItems()"
          >reject</v-btn
        >
      </v-actions>
      <!-- filter -->
      <v-expansion-panels
        class="custom-control_outlined m-0"
        ref="filterPopupRef"
        readonly
        style="max-width: 300px; margin-bottom: 28px; height: 56px"
      >
        <v-expansion-panel variant="outlined" @click="handlefilterPopup">
          <v-expansion-panel-title
            >Filter
          </v-expansion-panel-title>
        </v-expansion-panel>
      </v-expansion-panels>
      </v-row>
    </v-card-title>
    <!-- table content -->
    <v-layout column>
      <v-col cols="12" style="overflow: auto" class="p-0">
        <v-data-table hover
          density="compact"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          :loading="loading"
          :items-per-page="pageSize"
          loading-text="Loading Data... Please wait"
          class="elevation-1"
          return-object
        >
        <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>
    <div>
      <v-row class="ml-2 pb-0">
        <v-col cols="3" sm="3" class="PaddingItemPerPage d-flex mt-3">
          <label class="" style="margin-top: -2px;">Rows Per Page</label>
          <v-select v-model="pageSize" :items="pageSizes" class="custom-pagination-ui" @update:modelValue="handlePageSizeChange"
            variant="outlined" style="width: 40px;margin-left: 120px;margin-top:-10px;position:absolute;"></v-select>
        </v-col>
        <span class="item-selected"> <span v-if="selected.length == 1">{{ selected.length }} Item Selected</span> <span
            v-if="selected.length > 1">{{ selected.length }} Items Selected</span> </span>
        <v-spacer></v-spacer>
        <span class="pt-3 mt-3 mr-5" v-if="this.totalCount > 0">Showing Results {{ (this.page - 1) * this.pageSize + 1 }}
          - {{ Math.min(this.page * this.pageSize, this.totalCount) }} of {{ this.totalCount }}</span>
        <v-col cols="2" sm="2" class="PaddingItemPerPage custom-column-ui">
          <v-pagination v-model="page" :length="totalPages" total-visible="7" class="custom-pagination-ui"
            @update:modelValue="handlePageChange" circle></v-pagination>
        </v-col>
      </v-row>
    </div>
    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog
        content-class="filter-putaway"
        v-model="filterPopup"
        persistent
        max-width="724px"
      >
        <v-card>
          <v-card-actions>
            <v-row>
              <v-col>
                <v-text-field
                  color="primary"
                  prepend-inner-icon="mdi-magnify"
                  v-model="article_id"
                  label="Article Id"
                  variant="outlined"
                  class="ma-2"
                  style="max-width: 350px"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-autocomplete
                  color="primary"
                  v-model="gradeSelected"
                  :items="gradelist"
                  label="Grade"
                  multiple
                  variant="outlined"
                  class="ma-2"
                  style="max-width: 350px"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn size="small" variant="text" color="normal" @click="filterPopup = false"
              >CANCEL</v-btn
            >
            <v-btn
              size="small"
              variant="flat"
              :color="this.selected.length == 0 ? '' : 'primary'"
              @click="applyFilters()"
              :disabled="
                this.article_id.length == 0             "
              >APPLY FILTER(S)</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card>
</template>
<script>
import HeaderComponent from "./../../../../commoncomponents/HeaderComponent";
export default {
  data() {
    return {
      headerText: "Pending Return Request Approval",
      search: "",
      pending_return_search: "",
      loading: false,
      headers: [
        { title: "Tag ID", value: "tag_id", align: "start", sortable: false },
        { title: "Article Id", value: "article_id" },
        {
          title: "Article Description",
          value: "article_description",
          width: "60%",
          align: "start",
        },
        { title: "Grade", value: "grade" },
      ],
      filterPopup: false,
      table_data: [],
      confirmationModelDelete: false,
      article_id: "",
      gradeSelected: null,
      gradelist: "",
      pageSizes: [100, 200, 500],
      selected: [],
      totalPages: 1,
      totalCount: '',
      pageSize: 100,
      page: 1,
      successPopUp: false,
      accessMessage: "",
      acceptOrReject: "",
      successmessage: "",
      alert_type: "success",
      alert: false,
      alert_message: "",
    };
  },

  components: {
    HeaderComponent,
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      this.selected = [];
      this.table_data = [];
      const searchArray = [];
      if (this.pending_return_search != "") {
        const parts = this.pending_return_search.split(",");
        for (let i = 0; i < parts.length; i++) {
          searchArray.push(parts[i]);
        }
      }
      const params = {
        search: searchArray,
        page: this.page,
        per_page: this.pageSize,
      };
      this.$httpSecured
        .get("/api/v1/items/pending_return_requests", { params: params })
        .then((response) => {
          if (response.data) {
            this.table_data = response.data.items;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count
            this.gradelist = response.data.items.map((x) => x.grade);
            this.gradelist.sort();
            this.loading = false;
            this.pending_return_search = "";
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    handlefilterPopup() {
      document.documentElement.style.setProperty(
        "--dialog-ypos",
        (
          this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 20
        ).toString() + "px",
      );
      this.filterPopup = true;
    },

    applyFilters() {
      this.loading = true;
      const params = {
        article_ids: this.article_id,
        grades: this.gradeSelected,
        page: this.page,
        per_page: this.pageSize,
      };
      this.$httpSecured
        .get("/api/v1/items/pending_return_requests", { params })
        .then((response) => {
          if (response.data) {
            this.table_data = response.data.items;
            this.loading = false;
            this.article_id = "";
            this.gradeSelected = "";
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
      this.filterPopup = false;
    },
    rejectItems() {
      this.confirmationModelDelete = true;
      this.acceptOrReject = "rejected";
      this.accessMessage = "Are you sure! You want reject?";
    },
    approveItems() {
      this.confirmationModelDelete = true;
      this.acceptOrReject = "accepted";
      this.accessMessage = "Are you sure! You want Approve?";
    },
    confirmedFunc() {
      const selectedId = this.selected.map((x) => x.id);
      if (this.acceptOrReject == "accepted") {
        this.$httpSecured
          .post("/api/v1/items/approve_return_request", { ids: selectedId })
          .then((response) => {
            if (response.data) {
              this.successPopUp = true;
              this.confirmationModelDelete = false;
              this.successmessage = response.data.message;
            } else {
              this.showAlert("error", "No Data Found");
            }
          })
          .catch((error) => {
            this.showAlert(
              "error",
              "Something went wrong from Network" + error,
            );
            this.loading = false;
          });
      } else if (this.acceptOrReject == "rejected") {
        this.$httpSecured
          .post("/api/v1/items/reject_return_request", { ids: selectedId })
          .then((response) => {
            if (response.data) {
              this.successPopUp = true;
              this.confirmationModelDelete = false;
              this.successmessage = response.data.message;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch((error) => {
            this.showAlert(
              "error",
              "Something went wrong from Network" + error,
            );
            this.loading = false;
          });
      }
      this.acceptOrReject = "";
    },
    afterClickOkLoadData() {
      this.successPopUp = false;
      this.page = 1;
      this.pending_return_search = "";
      this.loadData();
    },
    handlePageChange(value) {
      this.page = value;
      this.pending_return_search = "";
      this.loadData();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.pending_return_search = "";
      this.loadData();
    },
  },
};
</script>
<style scoped>
.custom-control_outlined .v-expansion-panel:before {
  box-shadow: none;
}

.custom-control_outlined button {
  min-height: 56px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.42);
  border-style: solid;
}

.custom-control_outlined button:focus {
  outline: none;
}

.v-dialog:has(.filter-putaway) {
  justify-content: right;
  align-items: baseline;
  top: var(--dialog-ypos);
}
</style>
